// extracted by mini-css-extract-plugin
export default {"fill-placeholder-child":"fill-placeholder-child_DaWqw","title":"title_H6Kx-","table-wrap":"table-wrap_8wPnQ","table":"table_anmdX"};